<template>
  <section id="services" class="section bg-light">
    <div class="container">
      <!-- Heading -->
      <h2
        class="text-10 fw-600 text-center mb-5"
        data-aos="fade-up"
        data-aos-once="true"
      >
        Expert Services
      </h2>
      <!-- Heading end-->
      <div class="list-services">
        <ul>
          <li
            class="d-inline-block p-3 m-2 shadow bg-white rounded"
            v-for="service in services"
            :key="service"
          >
            {{ service }}
          </li>
        </ul>
      </div>
    </div>
    <p class="text-center mt-5" data-aos="fade-up" data-aos-once="true">
      <a href="#" class="btn btn-outline-dark shadow-none rounded-0"
        >Read More</a
      >
    </p>
  </section>
</template>

<script>
export default {
  name: "Service_list",
  data() {
    return {
      services: [
        "User Story",
        "User Research",
        "Product Roadmap",
        "Flowchart",
        "User Flow",
        "User Experience Design",
        "Wireframing",
        "User Interface Design",
        "Prototypes",
        "Brand Design",
        "Mobile App UI/UX Design",
        "Website UI/UX Design",
        "Mockups",
        "Startup Business",
        "Admin Panel Design",
        "Web App Design",
        "Mobile App Icon Design",
        "App Screenshot Design",
        "Redesign Mobile app",
        "SaaS Website Design",
        "Product Page Design",
        "Improve Website Design",
        "Dashboard Design",
        "Portal Design",
        "Ecommerce Website Design",
        "Website Redesign",
        "Landing Pages Design",
        "Software Design",
        "Email & Newsletter Designs",
        "Graphic Design",
      ],
    };
  },
};
</script>

<style scoped>
.list-services li {
  background: white;
}
</style>
